<div class="login-wrapper">
    <div class="container-common">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="d-flex align-items-center minheight70vh">
                    <form class="login_box_outer w-100">
                        <div class="login-box max-WT-520">
                            <div class="login-right-block">
                                <div class="login-heading">
                                    <h4>OTP</h4>
                                </div>
                                <div class="login-box-body">
                                    <p class="common-paragrph text-center">Please enter the 4-digit OTP you received on
                                        your registered email address.</p>
                                    <div class="text-center">
                                        <ng-otp-input (onInputChange)="onOtpChange($event)"
                                            [config]="{length:4 , allowNumbersOnly : true}"></ng-otp-input>
                                    </div>
                                    <div class="d-flex justify-content-end mt-4">
                                        <span class="me-3">
                                            {{count}}
                                        </span>
                                        <span class="resend ms-auto  forgot-links">
                                            <a class="link font17" (click)="resendOtp()">
                                                Resend
                                            </a>
                                        </span>

                                    </div>
                                </div>
                                <div class="text-center mt40 admin-profile">
                                    <button type="button" class="btn btn-theme btn-large  width100 font-100"
                                        (click)="verifyOtp()">SUBMIT</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>